export default {
  placeholder: 'Vybrať úlohy údržby',
  unit: 'Diely',
};
